import { render, staticRenderFns } from "./circle4.vue?vue&type=template&id=8ffc0304&scoped=true&"
import script from "./circle4.vue?vue&type=script&lang=js&"
export * from "./circle4.vue?vue&type=script&lang=js&"
import style0 from "./circle4.vue?vue&type=style&index=0&id=8ffc0304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffc0304",
  null
  
)

export default component.exports